import { Routes, Route, Navigate, Link, useLocation } from 'react-router-dom'
import AuthGuard, { useCurrentUser } from './components/AuthGuard/AuthGuard'
import LoginPage from './pages/LoginPage'
import ReviewListPage from './pages/ReviewListPage'
import ReviewDetailPage from './pages/ReviewDetailPage'
import ReviewDiffPage from './pages/ReviewDiffPage'
import AdminPage from './pages/AdminPage'

function BrandLockup() {
  return (
    <Link
      to="/reviews"
      className="flex items-baseline gap-2 mr-6 hover:no-underline"
    >
      <span className="brace text-[18px]">
        {'{'}
        <span className="eyes">::</span>
        {'}'}
      </span>
      <span className="text-fg font-semibold tracking-[-0.01em] text-[14px] leading-none">
        samik<span className="text-accent">.</span>
        <span className="text-fg-dim font-normal">sh</span>
      </span>
    </Link>
  )
}

function NavLink({ to, label, active }: { to: string; label: string; active: boolean }) {
  const cls = active ? 'text-fg bg-overlay' : 'text-fg-dim hover:text-fg hover:bg-overlay'
  return (
    <Link
      to={to}
      className={`${cls} text-[12px] px-2 py-1 rounded-[3px] no-underline transition-colors`}
    >
      {label}
    </Link>
  )
}

function Shell() {
  const me = useCurrentUser()
  const initials = me?.githubLogin ? me.githubLogin.slice(0, 2).toUpperCase() : '??'

  const path = useLocation().pathname

  return (
    <div className="flex flex-col h-full bg-page text-fg overflow-hidden">
      <header className="flex items-center h-[46px] px-4 bg-raised border-b border-border-default shrink-0 z-10">
        <BrandLockup />
        <nav className="flex gap-0.5 flex-1">
          <NavLink to="/reviews" label="Reviews" active={path.startsWith('/reviews')} />
          <NavLink to="/admin/audit" label="Audit" active={path.startsWith('/admin')} />
        </nav>
        <div className="flex items-center gap-2">
          {me?.githubLogin ? (
            <>
              <div className="userchip">
                <div className="userchip-av">{initials}</div>
                @{me.githubLogin}
              </div>
              <form method="post" action="/auth/signout">
                <button
                  type="submit"
                  className="text-[11px] text-fg-dim hover:text-fg-muted bg-transparent border-0 p-0"
                >
                  sign out
                </button>
              </form>
            </>
          ) : (
            <Link
              to="/login"
              className="text-[11px] text-fg-dim hover:text-fg-muted no-underline"
            >
              sign in
            </Link>
          )}
        </div>
      </header>
      <main className="flex-1 flex flex-col min-h-0">
        <Routes>
          <Route path="/" element={<Navigate to="/reviews" replace />} />
          <Route path="/reviews" element={<ReviewListPage />} />
          <Route path="/:tenant/:repo/reviews/:reviewName" element={<ReviewDetailPage />} />
          <Route path="/:tenant/:repo/reviews/:reviewName/diff" element={<ReviewDiffPage />} />
          <Route path="/admin/audit" element={<AdminPage />} />
          <Route path="*" element={<Navigate to="/reviews" replace />} />
        </Routes>
      </main>
    </div>
  )
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/*"
        element={
          <AuthGuard>
            <Shell />
          </AuthGuard>
        }
      />
    </Routes>
  )
}
